import { render, staticRenderFns } from "./QcReport.vue?vue&type=template&id=13902a9b&scoped=true"
import script from "./QcReport.vue?vue&type=script&lang=js"
export * from "./QcReport.vue?vue&type=script&lang=js"
import style0 from "./QcReport.vue?vue&type=style&index=0&id=13902a9b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13902a9b",
  null
  
)

export default component.exports